import React from 'react';
import get from 'lodash/get';

import { ReactComponent as Dashboard } from 'Images/manage.svg';
import { ReactComponent as Automation } from 'Images/automation.svg';
import { ReactComponent as Planner } from 'Images/tasks_icon.svg';
import { ReactComponent as Reports } from 'Images/reports.svg';
import { ReactComponent as Analytics } from 'Images/analytics.svg';
import { ReactComponent as Users } from 'Images/icon_users.svg';
import { ReactComponent as KnowledgeBase } from 'Images/vuln-kb.svg';
import { ReactComponent as NotificationBell } from 'Images/icon-notifications-sidebar.svg';
import { ReactComponent as MCP } from 'Images/mcp_icon.svg';

import FFAnalytics from 'Images/ff_analytics.png';
import FFPlanner from 'Images/ff_planner.png';
import FFReports from 'Images/ff_reporting.png';
import FFNotifications from 'Images/ff_notifications.png';
import FFUsers from 'Images/ff_users.png';
import FFScheduler from 'Images/ff_scheduler.png';
import FFPipelines from 'Images/ff_pipelines.png';

export const selectIsOpen = (state) => get(state, 'sideBar.isOpen', false);
export const selectPagesData = () => {
  return [
    {
      name: 'Management',
      icon: <Dashboard />,
      subMenu: [
        {
          name: 'Management',
          url: '/workspaces',
          enabledByRole: true,
          enabledByFeature: true,
          subPaths: ['/workspaces', '/manage', '/feed', '/hosts', '/host', '/services', '/service', '/vulnerabilities', '/vulns', '/credentials']
        }
      ]
    },
    {
      name: 'Knowledge Base',
      icon: <KnowledgeBase />,
      subMenu: [
        {
          name: 'Knowledge Base',
          url: '/knowledge_base',
          enabledByRole: true,
          enabledByFeature: true,
          subPaths: ['/knowledge_base']
        }
      ]
    },
    // Analytics, Planner, Reports, Users and Notifications are Enterprise Edition-only
    // and don't exist in this build. Kept visible with enabledByFeature: false (product
    // decision: discoverable, not hidden) instead of calling the backend-driven
    // isEnabledByRole/isEnabledByFeature checks -- those depend on what a given backend
    // reports, which has nothing to do with whether this frontend build has the screen.
    {
      name: 'Analytics',
      icon: <Analytics />,
      url: '/analytics',
      subMenu: [
        {
          name: 'Analytics',
          url: '/analytics',
          enabledByRole: true,
          enabledByFeature: false,
          subPaths: ['/analytics'],
          FF: {
            image: FFAnalytics,
            description: 'upgradeLicense.sidebar.analytics.description'
          }
        }
      ]
    },
    {
      name: 'Planner',
      icon: <Planner />,
      subMenu: [
        {
          name: 'Planner',
          url: '/planner',
          enabledByRole: true,
          enabledByFeature: false,
          FF: {
            image: FFPlanner,
            description: 'upgradeLicense.sidebar.planner.description'
          }
        }
      ]
    },
    {
      name: 'Reports',
      icon: <Reports />,
      subMenu: [
        {
          name: 'Reports',
          url: '/report',
          enabledByRole: true,
          enabledByFeature: false,
          subPaths: ['/report', '/legacy-report', '/templates', '/styles', '/scope', '/report-builder'],
          FF: {
            image: FFReports,
            description: 'upgradeLicense.sidebar.reporting.description'
          }
        }
      ]
    },
    // Automation submenu items are always enabled in this build: community's backend has
    // no per-role permission concept (single implicit admin), and its hardcoded permission
    // allow-list (get_user_permissions()) doesn't even report 'pipelines'/'jobs' at all, so
    // gating these by isEnabledByRole/isEnabledByFeature made Pipelines and Jobs disappear
    // from the menu (and their routes unreachable) even though both features work fine here.
    {
      name: 'Automation',
      icon: <Automation />,
      subMenu: [
        {
          name: 'Runners & Security Scanners',
          url: '/automation/agents',
          enabledByRole: true,
          enabledByFeature: true
        },
        {
          name: 'Scheduler',
          url: '/automation/schedule',
          enabledByRole: true,
          enabledByFeature: true,
          subPaths: ['/automation/schedule', '/automation/schedule_cloud'],
          FF: {
            image: FFScheduler,
            description: 'upgradeLicense.sidebar.scheduler.description'
          }
        },
        {
          name: 'Pipelines',
          url: '/automation/pipelines',
          enabledByRole: true,
          enabledByFeature: true,
          subPaths: ['/automation/pipelines'],
          FF: {
            image: FFPipelines,
            description: 'upgradeLicense.sidebar.pipelines.description'
          }
        },
        {
          name: 'Jobs',
          url: '/automation/jobs',
          enabledByRole: true,
          enabledByFeature: true,
          subPaths: ['/automation/jobs'],
          FF: {
            image: FFPipelines,
            description: 'upgradeLicense.sidebar.pipelines.description'
          }
        }
      ]
    },
    {
      name: 'Users',
      icon: <Users />,
      subMenu: [
        {
          name: 'Users',
          url: '/users',
          enabledByRole: true,
          enabledByFeature: false,
          subPaths: ['/users'],
          FF: {
            image: FFUsers,
            description: 'upgradeLicense.sidebar.users.description'
          }
        }
      ]
    },
    {
      name: 'Notifications',
      icon: <NotificationBell />,
      subMenu: [
        {
          name: 'Log',
          url: '/notifications-log',
          enabledByRole: true,
          enabledByFeature: false,
          FF: {
            image: FFNotifications,
            description: 'upgradeLicense.notifications.description'
          }
        }
      ]
    },
    {
      name: 'Faraday MCP',
      icon: <MCP />,
      subMenu: [
        {
          name: 'Faraday MCP',
          url: '/mcp',
          enabledByRole: true,
          enabledByFeature: true
        }
      ]
    }
  ];
};
